var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"page-title"},[_vm._v("Moje članarine ")]),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.periods,"items-per-page":10},scopedSlots:_vm._u([{key:"item.start_date",fn:function(ref){
var item = ref.item;
return [_vm._v("\r\n            "+_vm._s(item.start_date)+" - "+_vm._s(item.end_date)+"\r\n        ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }